var $54b47fc030b7b21e$exports = {};
/** Hämtar HTML element med id "menu" 
 * Funktionen körs när man kanppar på "menuEl"
 * Funktionen visar eller döljer dropdown menu
*/ const $54b47fc030b7b21e$var$menuEl = document.getElementById("menu");
const $54b47fc030b7b21e$var$dropdownEl = document.getElementById("dropdown-menu");
$54b47fc030b7b21e$var$menuEl.addEventListener('click', ()=>{
    $54b47fc030b7b21e$var$dropdownEl.classList.toggle('show');
});


//# sourceMappingURL=pages.8d202a2c.js.map
